// extracted by mini-css-extract-plugin
export default {"div":"user-account_div__E3-ul","show_item_text":"user-account_show_item_text__pVqu1"};